import CreditProductItem from './CreditProductItem.js';

export default CreditProductItem;
